import { render, staticRenderFns } from "./ElCarouselV2.vue?vue&type=template&id=3ef1827a"
import script from "./ElCarouselV2.vue?vue&type=script&lang=js"
export * from "./ElCarouselV2.vue?vue&type=script&lang=js"
import style0 from "./ElCarouselV2.vue?vue&type=style&index=0&id=3ef1827a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports